// 같은 deliveryGroup 내 아이템은 동일한 배송비를 공유하므로 1회만 부과.
// BE 응답이 일시적으로 불일치할 경우를 방어하기 위해 Math.max로 가장 큰 값을 채택한다.
export const calcGroupShippingFee = (
  items: { shippingFee?: number | null }[],
  productAmount: number,
  opts: { isBundle: boolean; bundleFreeThreshold?: number }
): number => {
  const base = items.reduce<number>((max, it) => {
    if (typeof it.shippingFee === 'number') {
      return Math.max(max, it.shippingFee);
    }
    return max;
  }, 0);
  const isFree =
    opts.isBundle &&
    typeof opts.bundleFreeThreshold === 'number' &&
    productAmount >= opts.bundleFreeThreshold;
  return isFree ? 0 : base;
};
